import { radius, spacing } from "@yleisradio/yds-core";
import styled, { css } from "styled-components";

import { imageUrl } from "../../helpers/images";
import i18n from "../../service/i18n";
import { fontFamily } from "../../styles/global";
import { recommendationTextColor } from "../../styles/variables";
import { ImageObject } from "../../types/player-api";

export const Background = styled.div`
  border-radius: ${radius.LARGE};
  height: 100%;
  top: 0;
  position: absolute;
  width: 100%;
`;

export const openSansBold = css`
  color: ${recommendationTextColor};
  font-weight: bold;
  ${fontFamily}
`;

export const RecommendationCardTitle = styled.span`
  &&& {
    color: ${recommendationTextColor};
    display: block;
    font-size: 1.125em;
    margin: 1em 0;
    position: relative;
    text-shadow: 0 0 1px black;
    z-index: 1;
    ${openSansBold}
  }
`;

export const smallHeaderFont = css`
  font-size: 1em;
`;

export const RecommendationBackground = styled(Background)`
  color: ${recommendationTextColor};
  font-size: initial;
  ${fontFamily}
`;

export const BackgroundGradient = styled(Background)`
  background: linear-gradient(to right, black, transparent);
`;

export const TextShadow = styled.div`
  text-shadow: 0 0 1px black;
`;

export const watchNext = (language: string): string =>
  `${i18n("katso_seuraavaksi", { language })}:`;

const getImageUrl = (props: { image?: ImageObject }) =>
  imageUrl({
    id: props.image?.id || "",
    serviceId: "yle-areena"
  });

export const RecommendationItemBackground = styled.div<{ image?: ImageObject }>`
  border-radius: ${radius.LARGE};
  background: url(${props => getImageUrl(props)}) no-repeat;
  background-size: contain;
  padding-bottom: 56.25%; /* Aspect ratio 16 : 9 */
  position: relative;
`;

export const RecommendationList = styled.div`
  display: flex;
  margin-top: ${spacing.SPACING_12};
  overflow: hidden;
`;
